export default {
  DISCOUNT: 'discount',
  FLAT_RATE: 'flat_rate',
  HOURLY: 'hourly',
  SUPPLIES: 'supplies',
  ADDITIONAL_HOURS: 'additional_hours',
  VALUATION_COVERAGE: 'valuation_coverage',
};
